// 引入axios
import Vue from 'vue'
import promise from 'es6-promise'
import axios from 'axios'
import store from '@/store/index'
// import localStorage from '../storage/localStorage'
import Cookie from 'js-cookie'
promise.polyfill()

export const baseURL = 'http://www.doravip.net/api'
export const uploadURL = (process.env.NODE_ENV === 'production') ? 'http://www.doravip.net/api' : '/api'

const service = axios.create({
  baseURL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  withCredentials: true,
  timeout: 20000 // 请求超时 20s
})

// 请求拦截器
service.interceptors.request.use(config => {
  // 是否为当前的请求加上请求头 token
  // if (localStorage.get('token')) {
  //   config.headers['x-auth-token'] = localStorage.get('token')
  // }
  if (Cookie.get('token')) {
    config.headers['Authorization'] = Cookie.get('token')
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.data.code === '20005' || response.data.code === '20004') {
      store.commit('resetVuex')
      Cookie.remove('token')
      store.commit('IS_LOGIN', false) // 清除顶部导航栏数据
      store.commit('SHOW_LOGIN') // 展示登录弹框
    }
    return response
  },
  err => {
    // 失败响应
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = 'The request is invalid. Please check whether the parameters are correct!'
          break

        case 401:
          err.message = 'Unauthorized access denied!'
          break

        case 403:
          err.message = 'Access denied!'
          break

        case 404:
          err.message = 'Address does not exist!'
          break

        case 408:
          err.message = 'Request timeout!'
          break

        case 500:
          err.message = 'System error!'
          break

        case 501:
          err.message = 'This method is not implemented!'
          break

        case 502:
          err.message = 'Network management error!'
          break

        case 503:
          err.message = 'Service unavailable!'
          break

        case 504:
          err.message = 'Gateway request timeout!'
          break

        case 505:
          err.message = 'The HTTP version is not supported!'
          break

        default:
      }
      if (err.response.data.error) {
        err.message = err.response.data.error
      }
      Vue.prototype.$message.closeAll()
      // Vue.prototype.$message.error(err.message)
      // router.push({name: 'error', params: {message: err.message, status: err.response.status}})
    }
  }
)
export default service



// WEBPACK FOOTER //
// ./src/util/server.js